import './ActivityIndicator.css';
import { useSelector } from 'react-redux';

export const GlobalActivityIndicator = () => {
  const loadingReduxStore = useSelector(state => {
    return state.loading;
  });

  let className = "mainActivityIndicator";
  if (loadingReduxStore.isLoading) {
    className += " isLoading";
  }

  return (
    <div className={className}>
    </div>
  )
}

export const HeaderActivityIndicator = (props) => {
  let className = "mainActivityIndicator";
  if (props.isLoading) {
    className += " isLoading absolutePositioned";
  }

  return (
    <div className={className}>
    </div>
  )
}